module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAANpJREFUOBHt1bENhCAUBuB3l+tcQCo7R2AEN2ARmUMWcQMWICFxASuspHeAu8ME84yoXIK5Rhrgl/eFvBh9GGPecMF4ObMoiqT0MAzwTCoi7IaXZvynFX3fQ9d1yy38wloL0zT5bXA+vHEIHscRmqYBpVQQ9OEh7A/52aFCCKCUQlVVPg7O0TBGGWNBDIfRMC6KWUfDhBCo6xq01tC27akdDTsJ41LKQ3z+CO2dKMtyxvBzh3POIcsyHG/Wp/Cm4hvkeR6KV9lPrVhVnmxueGnQZa2Y3wr3j0o9PhlmOt6s7t8MAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn_1st_page.png
// module id = DTLH
// module chunks = 1